import { DialogStepProps } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/components/DialogStepContent';
import { AutoCartEdit } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/EditCheckoutSessionCartDialog/components/steps/CartEdit/components/AutoCartEdit';
import { DefaultCartEdit } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/EditCheckoutSessionCartDialog/components/steps/CartEdit/components/DefaultCartEdit';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';
import { hasSelectedAgentOnlyAutoPaymentMethods } from '@/utils/hasSelectedAgentOnlyAutoPaymentMethods';

export const CartEdit = (props: DialogStepProps) => {
  const {
    state: { selectedAgent },
  } = useApplicationContext();

  if (!selectedAgent) {
    return null;
  }

  // Decide type of cart to show
  const showAutoCart = hasSelectedAgentOnlyAutoPaymentMethods(selectedAgent);

  if (showAutoCart) {
    return <AutoCartEdit {...props} />;
  }

  return <DefaultCartEdit {...props} />;
};
